module.exports = __webpack_public_path__ + "static/media/bk.22ad4205.jpg";